import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';

import { ConfigDetail, configRegistryKeys } from './useConfigsQuery';

export interface CreateConfigVariables {
  key: string;
  /** The value as text, exactly as typed. The server parses and validates it. */
  value: string;
  /** Null creates the row with no shape contract — "must be valid JSON" only. */
  schema: unknown | null;
  note: string | null;
}

export const useCreateConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: CreateConfigVariables): Promise<ConfigDetail> => {
      const { data } = await post<ConfigDetail>('/v1.0/internals/configs', variables);
      return data;
    },
    // Invalidating the whole registry rather than the one list key: the new row
    // has to appear under every search term currently cached, not just the
    // active one.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: configRegistryKeys.all }),
  });
};

export default useCreateConfigMutation;
